import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Card, Tab, Tabs } from 'react-bootstrap';
import { useOutletContext, useParams, useNavigate } from 'react-router-dom';
import spinnerIcon from './/./../assets/img/loadingSpinner.gif'
import comingSoon from './/./../assets/img/coming-soon.png'
import PaginationComponent from '../components/pagination/PaginationComponent.js'
import { useAuth0 } from "@auth0/auth0-react";
import { apiGet, apiPut } from "../services/AuthService.js";
import { btnGold, btnRed, boxshadowHover, boxshadowUnHover, header, formLabel, inputSm, goldInputFocus, paginationStyle, activePaginationStyle, COLORS } from '../styles/goldTheme.js'

const SendingOperators = props => {

    //properties
    const baseUrl = process.env.REACT_APP_API_BASEURL;
    const { getAccessTokenSilently } = useAuth0();

    //stateful properties (hooks)
    const params = useParams();
    const [currentAccount, accountProfile, setAccountProfile, toggleIsShowSidebarMd, setIsShowSidebarMd] = useOutletContext();
    const navigate = useNavigate();
    const [pageStatus, setPageStatus] = useState('loading');
    const [dataStatus, setDataStatus] = useState('loading');
    const [pageErrors, setPageErrors] = useState('');
    const [dataErrors, setDataErrors] = useState('');
    const [companies, setCompanies] = useState([]);
    const [states, setStates] = useState(['Any', 'AZ', 'CO', 'ND', 'TX']);
    const [companyTypes, setCompanyTypes] = useState([{ id: 1, type: 'Sender' }, { id: 4, type: 'Receiver' }]);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [isDirty, setIsDirty] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(true);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [dataCriteria, setDataCriteria] = useState({
        dataFileId: params.id,
        skipCount: 0,
        takeCount: 50,
        cdexSenderCode: '',
        companyName: '',
        address: '',
        city: '',
        state: 'Any',
        zip: '',
        //companyTypeId: currentAccount.accountTypeId !== 3 ? 1 : 4
        companyTypeId: currentAccount.accountTypeId !== "Sender" ? 1 : 4
    });
    const [rowCount, setRowCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const companyTopRef = useRef(null);
    const editRef = useRef(null);

    //initialize page
    useEffect(() => {
        (async () => {
            //console.log('Initializing page...');

            if (setIsShowSidebarMd)
                setIsShowSidebarMd(true);

            await populateCompanies(1, dataCriteria.companyTypeId)
                .then(response => {
                    setPageStatus('ready')
                })
                .catch(ex => {
                    setPageStatus('error');
                    setPageErrors(ex.message);

                    setDataStatus('error');
                    setDataErrors(ex.message);
                })
                .finally(response => {
                    //do something
                })
        })();
    }, []);

    //populate companies
    const populateCompanies = async (currentPage, companyTypeId, reset) => {
        //console.log('Current Page: ' + currentPage);
        
        //note: have to recalcaulate skipCount here since state updates aren't active until re-render
        let skipCount = (currentPage === 1 ? 0 : (currentPage - 1) * dataCriteria.takeCount);
        //console.log('Skip Count: ' + skipCount);

        //setDataStatus('loading');

        const currentCriteria = {
            dataFileId: dataCriteria.dataFileId,
            cdexSenderCode: (reset ? '' : dataCriteria.cdexSenderCode),
            companyName: (reset ? '' : dataCriteria.companyName),
            address: (reset ? '' : dataCriteria.address),
            city: (reset ? '' : dataCriteria.city),
            state: (reset ? 'Any' : dataCriteria.state),
            zip: (reset ? '' : dataCriteria.zip),
            companyTypeId: (reset ? 1 : companyTypeId),
            skipCount: skipCount,
            takeCount: dataCriteria.takeCount
        }
        
        await getCompanies(currentCriteria)
            .then(response => {
                if (response.data.length === 0) {
                    //console.log(response.data);
                    setHoveredIndex(null);
                    setSelectedIndex(null);
                    setSelectedCompany(null);
                    setIsDirty(false);
                    setDataStatus('nodata')
                }
                else {
                    //console.log('Company Count: ' + response.data[0].rowCount);
                    setIsReadOnly(currentCriteria.companyTypeId != 4);
                    setHoveredIndex(null);
                    setSelectedIndex(0);
                    setSelectedCompany(response.data[0]);
                    setIsDirty(false);

                    setRowCount(response.data[0].rowCount);
                    setCompanies(response.data);
                    setDataStatus('ready')
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
                //console.log('Yo CompanyType: ' + companyTypeId);
                //console.log('Yo ReadOnly: ' + isReadOnly);
            })
    };

    //get companies
    const getCompanies = async (criteria) => {
        //console.log('Getting Companies...');

        const apiUrl = 'accounts/' + currentAccount.id + '/sendingoperators?skipcount=' + criteria.skipCount + '&takecount=' + criteria.takeCount
            + (criteria.cdexSenderCode === "" ? '' : '&cdexSenderCode=' + criteria.cdexSenderCode)
            + (criteria.companyName === "" ? '' : '&companyName=' + criteria.companyName)
            + (criteria.address === "" ? '' : '&address=' + criteria.address)
            + (criteria.city === "" ? '' : '&city=' + criteria.city)
            + (criteria.state === "Any" ? '' : '&state=' + criteria.state)
            + (criteria.zip === "" ? '' : '&zip=' + criteria.zip);
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json }
    };

    //handle form control changes
    const handleSearchChange = async (event) => {
        event.preventDefault();

        const fieldName = event.target.name;
        const value = event.target.value;
        console.log('Field: ' + fieldName + ', Value: ' + value);

        setDataCriteria({
            ...dataCriteria,
            [fieldName]: value
        });
    }

    //handle form type control change
    const handleSearchTypeChange = async (event) => {
        event.preventDefault();

        const fieldName = event.target.name;
        const value = event.target.value;
        console.log('Field: ' + fieldName + ', Value: ' + value);

        setDataCriteria({
            ...dataCriteria,
            [fieldName]: value,
            skipCount: 0
        });

        setCurrentPage(1);

        await populateCompanies(1, value);
    }

    //handle edit control changes
    const handleEditChange = (event) => {
        event.preventDefault();
        
        const fieldName = event.target.name;
        let value = event.target.value;
        //console.log('Field: ' + fieldName + ', Value: ' + value);

        if (fieldName == 'cdexSenderCode') {
            if (value.length > 2) {
                value = value.substring(0, 2);
            }
        }

        //create modified company
        const modifiedCompany = {
            ...selectedCompany,
            [fieldName]: value
        };

        //set isDirty flag
        companies.map((company, index) => {
            if (index === selectedIndex) {
                if (checkIsDirty(company, modifiedCompany)) {
                    setIsDirty(true);
                }
                else {
                    setIsDirty(false);
                }
            }
        });        

        setSelectedCompany(modifiedCompany);
    }

    function checkIsDirty(object1, object2) {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);

        if (keys1.length !== keys2.length) {
            return true;
        }

        for (let key of keys1) {
            if (object1[key] !== object2[key]) {
                return true;
            }
        }

        return false;
    }

    //handle form button clicks
    const handleFormButtons = async (buttonId) => {
        
        switch (buttonId) {
            case "Edit":
                console.log('editing...');
                setDataStatus('editing');
                break;
            case "Cancel":
                console.log('cancelling...');                

                setSelectedCompany(companies[selectedIndex]);
                setIsDirty(false);

                setDataStatus('ready');

                //companyTopRef.current.scrollIntoView();
                //editRef.current.scrollIntoView();                
                break;
            case "Save":
                console.log('saving...');
                setIsDirty(false);
                await updateCompany();

                //companyTopRef.current.scrollIntoView();
                //editRef.current.scrollIntoView();
                break;
        }
    }

    //update company
    const updateCompany = async () => {
        console.log('Saving company...');
        //setDataStatus('loading');

        console.log('Id: ' + selectedCompany.id + ', Company Name: ' + selectedCompany.companyName);

        await saveCompany(selectedCompany)
            .then(response => {
                if (response.success) {
                    setCompanies(companies.map((company, index) => {
                        if (index === selectedIndex) {
                            return selectedCompany;
                        }
                        else {
                            return company;
                        }
                    }));
                    console.log('ready');
                    //setDataStatus('ready');
                }
                else {
                    //TODO: figure out what to do here
                    console.log('nodata');
                    //setDataStatus('nodata')
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    };

    //save company
    const saveCompany = async (selectedCompany) => {
        //console.log('Saving Company...');

        //let apiUrl = baseUrl + 'accounts/' + currentAccount.id + '/updatesendingoperator/' + selectedCompany.id;
        //let body = JSON.stringify(selectedCompany);

        //console.log(apiUrl);
        //console.log(body);

        //let result = await fetch(apiUrl, {
        //    method: 'PUT',
        //    headers: { 'Content-Type': 'application/json' },
        //    body: JSON.stringify(selectedCompany)
        //})
        //    .then(response => {
        //        if (response.ok) {
        //            console.log(response);
        //            return true;
        //        }
        //        else {
        //            return false;
        //        }
        //    })
        //    .catch(ex => {
        //        throw ex;                                   //use this to throw the raw error object
        //        //throw new Error('Bad Url: ' + ex);        //use this to throw custom error message
        //    })

        //return { success: result };

        const apiUrl = 'accounts/' + currentAccount.id + '/updatesendingoperator/' + selectedCompany.id;
        const jsonBody = JSON.stringify(selectedCompany);
        //console.log(apiUrl);
        //console.log(jsonBody);

        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);

        return { success: response.ok };
    };

    //submit form
    const submitForm = async (e) => {
        //e.preventDefault();
        //setDataStatus('loading');

        setDataCriteria({
            ...dataCriteria,
            skipCount: 0
        });

        setCurrentPage(1);

        await populateCompanies(1, dataCriteria.companyTypeId);
    };

    //handle reset button
    const handleResetButton = async () => {

        //setDataStatus('loading');

        setDataCriteria({
            ...dataCriteria,
            cdexSenderCode: '',
            companyName: '',
            address: '',
            city: '',
            state: 'Any',
            zip: '',
            companyTypeId: 1,
            skipCount: 0
        });

        setCurrentPage(1);

        await populateCompanies(1, dataCriteria.companyTypeId, true);
    };

    //handle mouse over
    const handleMouseOver = async (index) => {
        console.log('Mouse Over: ' + index);

        if (index != selectedIndex) {
            setHoveredIndex(index);
        }
    };

    //handle mouse leave
    const handleMouseLeave = async (index) => {
        console.log('Mouse Leave: ' + index);

        if (index != selectedIndex) {
            setHoveredIndex(null);
        }
    };

    //handle mouse click
    const handleMouseClick = async (index) => {
        console.log('Mouse Click: ' + index);

        setHoveredIndex(null);
        setSelectedIndex(index);
        setSelectedCompany(companies[index]);
        setIsDirty(false);
    };

    //handle page click
    const handlePageClick = async (currentPage) => {
        //console.log('Current Page: ' + currentPage);

        //setDataStatus('loading');

        setDataCriteria({
            ...dataCriteria,
            skipCount: 0
        });

        //don't need to do here, since pagination component sets before calling this method
        //setCurrentPage(1);

        await populateCompanies(currentPage, dataCriteria.companyTypeId);
    };

    //render page loading
    //note: spinner overlay will eventually be at the page level (I think)
    const showPageLoading = () => {
        return (
            <div>
                <img src={spinnerIcon} alt="loading..." />
            </div>
        );
    }

    //render page loading
    const showDataLoading = () => {
        return (
            <Row>
                <img src={spinnerIcon} alt="loading..." />
            </Row>
        );
    }

    //render page loading
    const showComingSoon = () => {
        return (
            <Row>
                <Col style={{ display: 'flex', justifyContent: 'center', marginTop: '100px' }}><img src={comingSoon} alt="Coming Soon!" style={{ width: '75%', height: 'auto' }} /></Col>
            </Row>
        );
    }

    //render page error
    const showPageError = () => {
        return (
            <div>
                Oops, there was a page load error: {pageErrors}
            </div>
        );
    }

    //render data error
    const showDataError = () => {
        return (
            <Row>
                Oops, there was a data load error: {dataErrors}
            </Row>
        );
    }

    //render table container
    const showTableContainer = () => {
        return (
            <Card className="mb-4" style={{ background: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 14px rgba(0,0,0,.10)' }}>
                <Card.Header style={{ background: '#333333', color: '#f1f1f1', borderBottom: 'none', padding: '12px 16px' }}>
                    {showInputCriteria()}
                </Card.Header>
                <Card.Body style={{paddingLeft: '12px', paddingRight: '10px'}} >
                    {(() => {
                        switch (dataStatus) {
                            case 'nodata':
                                return <p>No Data Loaded.</p>
                            case 'loading':
                                return showDataLoading()
                            case 'ready':
                                return showData()
                            case 'error':
                                return showDataError()
                            default:
                                return <Row>No Data Loaded.</Row>
                        }
                    })()}
                </Card.Body>
                <Card.Footer style={{ background: '#f9fafb', borderTop: '1px solid #e5e7eb' }}>
                    <Container fluid>
                        <Row>
                            <Col className="d-flex justify-content-end">
                                <PaginationComponent
                                    itemsCount={rowCount}
                                    itemsPerPage={dataCriteria.takeCount}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    pageClickHandler={handlePageClick}
                                    alwaysShown={true}
                                    itemStyle={{ ...paginationStyle }}
                                    activeItemStyle={{ ...activePaginationStyle }}
                                />
                            </Col>
                        </Row>
                    </Container>
                </Card.Footer>
            </Card>
        );
    }

    //render companies
    const showData = () => {
        return (
            <Row>
                <Col xs={6} style={{ height: 'calc((100vh - 340px) * 0.85)', marginTop: '-16px', marginBottom: '-16px', overflow: 'auto', paddingRight: '0px', paddingLeft: '0px', borderRight: '1px solid #e5e7eb' }} >
                {(() => {
                    switch (dataStatus) {
                        case 'ready':
                            return showDataMaster()
                        default:
                            return null
                    }
                    })()}
                </Col>
                <Col xs={6} style={{ height: 'calc((100vh - 340px) * 0.85)', overflow: 'auto', paddingLeft: '20px', marginTop: '-10px', marginBottom: '-16px' }}>
                    {(() => {
                        switch (dataStatus) {
                            case 'ready':
                                return showDataDetail()
                            default:
                                return null
                        }
                    })()}
                </Col>
            </Row>
        );
    }

    //render master pane (companies list)
    const showDataMaster = () => {
        return (
            <>                
                <ul style={{ listStyleType: "none", height: '100%', marginRight: '12px' }}>
                    {companies.map((company, index) => (
                        <li key={company.id} ref={(index == 0 ? companyTopRef : null)}
                            style={{ cursor: 'pointer', paddingLeft: '20px', marginLeft: '-42px', marginRight: '0px', fontSize: '.9rem' }}
                            onMouseOver={() => handleMouseOver(index)}
                            onMouseLeave={() => handleMouseLeave(index)}
                            onClick={() => handleMouseClick(index)}>
                            <Row style={{
                                borderBottom: '1px solid #f3f4f6',
                                backgroundColor: (hoveredIndex == index ? '#f3f4f6' : (selectedIndex == index ? 'rgba(30, 64, 175, 0.10)' : 'transparent')),
                                color: (hoveredIndex == index ? '#1f2937' : (selectedIndex == index ? '#1E40AF' : '#374151')),
                                borderLeft: selectedIndex == index ? '3px solid #1E40AF' : '3px solid transparent',
                                transition: 'background 120ms ease, color 120ms ease'
                            }} >
                                <Col xs={2} >
                                    <div>{company.cdexSenderCode}</div>
                                </Col>
                                <Col xs={5} >
                                    <div>{company.companyName}</div>
                                    <div>{(company.additionalNameInfo ?? '' != '') && "(" + company.additionalNameInfo + ")"}</div>
                                </Col>
                                <Col xs={5} >
                                    <div>{company.address1}</div>
                                    <div>{company.city}</div>
                                </Col>
                            </Row>
                        </li>
                    ))}
                </ul>
            </>
        );
    }

    //render detail pane (company display or edit)
    const showDataDetail = () => {
        return (
            <>
                {(() => {
                    if (isReadOnly) {
                        //return showDataDisplay()
                        return showDataEdit()
                    }
                    else {
                        return showDataEdit()
                        //return showDataDisplay()
                    }
                })()}
            </>
        );
    }

    //render company detail
    const showDataDisplay = () => {
        return (
            <>
                <Row>
                    <Col xs={8}>
                        <div style={{ fontWeight: '600', fontSize: '1.25rem', marginTop: '10px' }} >Sender Detail</div>
                    </Col>
                    <Col xs={4} className="d-flex justify-content-end" style={{marginTop: '13px'}} >
                        Company Code:&nbsp;&nbsp;{selectedCompany.companyCode}&nbsp;&nbsp;&nbsp;&nbsp;
                    </Col>
                </Row>
                <Form style={{ borderTop: 'solid lightgray 1px', marginTop: '10px', paddingRight: '10px' }} />
                <Row style={{ paddingRight: '10px', paddingTop: '10px' }}>
                    <Col xs={2}>
                        Name:
                    </Col>
                    <Col xs={10}>
                        <div>
                            {selectedCompany.companyName}
                        </div>                        
                        <div>
                            {((selectedCompany.additionalNameInfo ?? '') == '' ? null : '(' + selectedCompany.additionalNameInfo + ')')}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={2}>
                        Address:
                    </Col>
                    <Col xs={10}>
                        <div>
                            {selectedCompany.address1} {selectedCompany.address2} {selectedCompany.address3}
                        </div>
                        <div>
                            {selectedCompany.city}, {selectedCompany.state} {selectedCompany.zip}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={2}>
                        Email:
                    </Col>
                    <Col xs={10}>
                        <div style={{ color: ((selectedCompany.email ?? '') == '' ? 'red' : 'black') }}>{(selectedCompany.email ?? '') == '' ? 'Not available' : selectedCompany.email}</div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={2}>
                        Phone:
                    </Col>
                    <Col xs={10}>
                        <div style={{ color: ((selectedCompany.phone ?? '') == '' ? 'red' : 'black') }}>{(selectedCompany.phone ?? '') == '' ? 'Not available' : selectedCompany.phone}</div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={2}>
                        Fax:
                    </Col>
                    <Col xs={10}>
                        <div style={{ color: ((selectedCompany.fax ?? '') == '' ? 'red' : 'black') }}>{(selectedCompany.fax ?? '') == '' ? 'Not available' : selectedCompany.fax}</div>
                    </Col>                    
                </Row>
                //<Row>
                //    <Col xs={2}>
                //        Tax Reg #:
                //    </Col>
                //    <Col xs={10}>
                //        <div style={{ color: ((selectedCompany.taxRegNumber ?? '') == '' ? 'red' : 'black') }}>{(selectedCompany.taxRegNumber ?? '') == '' ? 'Not available' : selectedCompany.taxRegNumber}</div>
                //    </Col>
                //</Row>
                <Row>
                    <Col xs={3}>
                        CDEX Sender Code:
                    </Col>
                    <Col xs={9}>
                        <div style={{ color: ((selectedCompany.cdexSenderCode ?? '') == '' ? 'red' : 'black') }}>{(selectedCompany.cdexSenderCode ?? '') == '' ? 'Not available' : selectedCompany.cdexSenderCode}</div>
                    </Col>
                </Row>
            </>
        );
    }

    //render company edit form
    const showDataEdit = () => {
        return (
            <>                
                <Row ref={editRef} style={{ paddingRight: '10px' }} >
                    <Col xs={5}>
                        <div style={{ fontWeight: '600', fontSize: '1.25rem', marginTop: '10px', color: '#1f2937' }} >Operator Detail</div>
                    </Col>
                    <Col xs={4}>
                        <div style={{ marginTop: '13px', color: '#6b7280' }} >CDEX Sender Code:</div>
                    </Col>
                    <Col xs={3}>
                        <div style={{ marginTop: '10px' }}>
                            <Form.Control name="cdexSenderCode" size="sm" aria-label="Cdex Sender Code" value={selectedCompany.cdexSenderCode ?? ''} style={{ ...inputSm }} onFocus={e => Object.assign(e.target.style, goldInputFocus)} onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })} onChange={handleEditChange} />
                        </div>
                    </Col>
                </Row>
                <Form style={{ borderTop: '1px solid #e5e7eb', marginTop: '10px', paddingRight: '10px' }} >
                    <Row style={{ paddingRight: '10px', paddingTop: '10px' }}>
                        <Col xs={2} style={{ color: '#6b7280' }}>
                            Name:
                        </Col>
                        <Col xs={10} style={{ color: '#1f2937' }}>
                            <div>
                                {selectedCompany.companyName}
                            </div>
                            <div>
                                {((selectedCompany.additionalNameInfo ?? '') == '' ? null : '(' + selectedCompany.additionalNameInfo + ')')}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={2} style={{ color: '#6b7280' }}>
                            Address:
                        </Col>
                        <Col xs={10} style={{ color: '#1f2937' }}>
                            <div>
                                {selectedCompany.address1} {selectedCompany.address2} {selectedCompany.address3}
                            </div>
                            <div>
                                {selectedCompany.city}, {selectedCompany.state} {selectedCompany.zip}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={2} style={{ color: '#6b7280' }}>
                            Email:
                        </Col>
                        <Col xs={10}>
                            <div style={{ color: ((selectedCompany.email ?? '') == '' ? '#b91c1c' : '#1f2937') }}>{(selectedCompany.email ?? '') == '' ? 'Not available' : selectedCompany.email}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={2} style={{ color: '#6b7280' }}>
                            Phone:
                        </Col>
                        <Col xs={10}>
                            <div style={{ color: ((selectedCompany.phone ?? '') == '' ? '#b91c1c' : '#1f2937') }}>{(selectedCompany.phone ?? '') == '' ? 'Not available' : selectedCompany.phone}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={2} style={{ color: '#6b7280' }}>
                            Fax:
                        </Col>
                        <Col xs={10}>
                            <div style={{ color: ((selectedCompany.fax ?? '') == '' ? '#b91c1c' : '#1f2937') }}>{(selectedCompany.fax ?? '') == '' ? 'Not available' : selectedCompany.fax}</div>
                        </Col>
                    </Row>
                    {/*<Row>*/}
                    {/*    <Col xs={2}>*/}
                    {/*        Tax Reg #:*/}
                    {/*    </Col>*/}
                    {/*    <Col xs={10}>*/}
                    {/*        <div style={{ color: ((selectedCompany.taxRegNumber ?? '') == '' ? 'red' : 'black') }}>{(selectedCompany.taxRegNumber ?? '') == '' ? 'Not available' : selectedCompany.taxRegNumber}</div>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    <Row style={{ marginTop: '-10px' }} >
                        <Col className="d-flex justify-content-end">
                            <Form.Group className="mb-3" controlId="buttonClear">
                                <Form.Label as={Row}><br /></Form.Label>
                                <Button id="editProfile"
                                    size='sm'
                                    style={{ ...btnRed, width: '100px' }}
                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnRed))}
                                    disabled={!isDirty}
                                    onClick={isDirty ? () => handleFormButtons('Cancel') : null}
                                >
                                    Cancel
                                </Button>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="buttonSubmit">
                                <Form.Label as={Row}><br /></Form.Label>
                                <Button
                                    size='sm'
                                    style={{ ...btnGold, marginLeft: '20px', width: '100px' }}
                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                    disabled={!isDirty}
                                    onClick={isDirty ? () => handleFormButtons('Save') : null}
                                >
                                    Save
                                </Button>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </>
        );
    }

    //pagination example
    //https://github.com/lukaaspl/ellipsis-pagination/blob/master/src/components/Pagination.js

    //render input criteria
    const showInputCriteria = () => {
        return (
            <Container fluid>
                <Form>
                    <Row>
                        <Col xs="auto">
                            <Form.Group className="mb-3" controlId="cdexSenderCode">
                                <Form.Label style={formLabel}>CDEX Sender Code</Form.Label>
                                <Form.Control name="cdexSenderCode" size="sm" aria-label="CDEX Sender Code" value={dataCriteria.cdexSenderCode} style={{ width: '240', ...inputSm }} onFocus={e => Object.assign(e.target.style, goldInputFocus)} onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })} onChange={handleSearchChange} />
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group className="mb-3" controlId="companyName">
                                <Form.Label style={formLabel}>Company Name</Form.Label>
                                <Form.Control name="companyName" size="sm" aria-label="Company Name" value={dataCriteria.companyName} style={{ width: '240', ...inputSm }} onFocus={e => Object.assign(e.target.style, goldInputFocus)} onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })} onChange={handleSearchChange} />
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group className="mb-3" controlId="buttonReset">
                                <Form.Label as={Row}><br /></Form.Label>
                                <Button
                                    type='button'
                                    size='sm'
                                    style={{ ...btnGold, width: '70px' }}
                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                    disabled={pageStatus !== 'ready'}
                                    onClick={pageStatus === 'ready' ? handleResetButton : null}
                                >
                                    Reset
                                </Button>
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group className="mb-3" controlId="buttonSubmit">
                                <Form.Label as={Row}><br /></Form.Label>
                                <Button
                                    size='sm'
                                    style={{ ...btnGold, width: '70px' }}
                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                    disabled={pageStatus !== 'ready'}
                                    onClick={pageStatus === 'ready' ? submitForm : null}
                                >
                                    Search
                                </Button>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Container>
        );
    }

    return (
        <div>
            <p style={{ fontSize: '1.75rem', fontWeight: '700', color: '#333333', margin: '16px 0 4px 0', textAlign: 'center' }}>My Operators</p>
            <div style={{ width: '90%', margin: '0 auto' }}>
                {(() => {
                    switch (pageStatus) {
                        case 'loading':
                            return showPageLoading()
                        case 'ready':
                            return showTableContainer()
                        case 'error':
                            return showPageError()
                        default:
                            return <p>No Page Loaded.</p>
                    }
                })()}
            </div>
        </div>
    );
}

export default SendingOperators;
